export default __webpack_public_path__ + "static/media/001-bear market.4d601b6e.svg";